import { space, colors } from './core'
import { textStyles } from './typography'

const baseInput = {
  width: '100%',
  boxSizing: 'border-box',
  ...textStyles.body.regular.regular,
  color: 'neutrals.4',
  borderRadius: '4px',
  borderColor: 'neutrals.3',
  borderStyle: 'solid'
}

const inputs = {
  default: {
    ...baseInput,
    borderWidth: '1px',
    borderColor: 'neutrals.3',
    height: '50px',
    px: 4,
    '&:hover': {
      borderColor: 'secondary.1'
    },
    '&:focus': {
      borderWidth: '2px',
      outline: 0,
      borderColor: 'secondary.1',
      px: `calc(${space[4]}px - 1px)`
    },
    'svg + &': {
      pl: 7,
      '&:focus': {
        pl: `calc(${space[7]}px - 1px)`
      }
    },
    'span + &': {
      pl: 6,
      '&:focus': {
        pl: `calc(${space[6]}px - 1px)`
      }
    },
    '&.error': {
      borderWidth: '2px',
      borderColor: 'error.2',
      px: `calc(${space[4]}px - 1px)`,
      'svg + &': {
        pl: `calc(${space[7]}px - 1px)`
      },
      'span + &': {
        pl: `calc(${space[6]}px - 1px)`
      }
    }
  }
}

const dateOfBirthSeperator = {
  ...textStyles.body.regular.regular,
  color: colors.neutrals[4],
  padding: `${space[3]}px ${space[2]}px`
}

export { inputs, dateOfBirthSeperator }
